module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "tit"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Title",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TITLE PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("DEDICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("El Qué Dirán")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holyoke, Mass.: An Ethnography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Simple Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer of Nene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Springs Girls Do Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Belindas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Hija de Changó")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Light in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love War Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Also_by",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ALSO BY FEMINIST PRESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "afp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_Feminist_Press",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ABOUT FEMINIST PRESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 66
// module chunks = 0